import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportsComponent } from './reports.component';
import { ReportsRoutingModule } from './reports.routes';
import { ComponentsModule } from '../../components/components.module';
import { TooltipModule } from 'ng2-tooltip-directive';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { BrowserModule } from '@angular/platform-browser';
import { EstablishmentReportComponent } from './establishment-report/establishment-report.component';
import { CompanyReportComponent } from './company-report/company-report.component';
import { GeneralViewComponent } from './company-report/general-view/general-view.component';
import { GroupViewComponent } from './company-report/group-view/group-view.component';
import { EconomyViewComponent } from './company-report/economy-view/economy-view.component';
import { PartnersViewComponent } from './company-report/partners-view/partners-view.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    ReportsComponent,
    EstablishmentReportComponent,
    CompanyReportComponent,
    GeneralViewComponent,
    GroupViewComponent,
    EconomyViewComponent,
    PartnersViewComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    ComponentsModule,
    FormsModule,
    NgxDatatableModule,
    ReportsRoutingModule,
    TooltipModule,
    NgbModule
  ]
})
export class ReportsModule {}
